<template>
    <div>
        <vue-headful :title="$t('applications_review_in_isc')" />
        <div
            id="todo-app"
            class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden"
        >
            <!--  Фильтры  -->
            <vs-sidebar
                class="items-no-padding custom-sidebar"
                parent="#todo-app"
                :click-not-close="clickNotClose"
                :hidden-background="clickNotClose"
                v-model="isEmailSidebarActive"
            >
                <Filters
                    @getDataOfStudents="getDataOfStudents"
                    @clearStudentsInList="clearStudentsInList"
                    :sidebarToggle="toggleTodoSidebar"
                />
            </vs-sidebar>

            <!--  Список заявок от студентов  -->
            <div
                :class="{ 'sidebar-spacer': clickNotClose }"
                class="overflow-y-auto no-scroll-content border border-solid d-theme-border-grey-light border-r-0 border-t-0 border-b-0"
            >
                <feather-icon
                    class="cursor-pointer emc_mobile_sidebar md:inline-flex lg:hidden ml-4 mr-4"
                    icon="MenuIcon"
                    @click.stop="toggleTodoSidebar(true)"
                />

   <!-- Строка поиска по ФИО -->
                <vx-input-group class="w-full">
                    <vs-input
                        icon-no-border
                        icon="icon-search"
                        size="large"
                        :maxlength="inputMaxLimit"
                        icon-pack="feather"
                        :placeholder="$t('name_of_student')"
                        v-model.lazy="searchQuery"
                        class="vs-input-no-border vs-input-no-shdow-focus w-full" />
                    <template slot="append">
                        <div class="append-text btn-addon">
                            <vs-button
                                @click="clearSearch()"
                                color="dark"
                                type="flat"
                                class="rounded"
                                icon-pack="feather"
                                icon="icon-x">
                            </vs-button>
                        </div>
                    </template>
                </vx-input-group>
                 <Applications
                    :listApplicationOfStudents="listApplicationOfStudents"
                    :urlForGetListStudents="urlForGetListStudents"
                    @addStudentsInList="addStudentsInList"
                    :secondPage="listApplicationOfStudents.next"
                    v-if="
                        listApplicationOfStudents &&
                        listApplicationOfStudents['results']
                    "
                />
            </div>

            </div>
        </div>
</template>

<script>
export default {
    name: "ApplicationReviewForISC",
    data() {
        return {
            clickNotClose: true,
            isEmailSidebarActive: true,
            listApplicationOfStudents: null,
            urlForGetListStudents: "advisors/study_plans/copy/",
            inputMaxLimit: 35,
            searchQuery:''
        };
    },
    components: {
        Filters: () =>
            import(
                "@/pages/Home/ApplicationForISC/ApplicationsReview/components/Filters"
            ),
        Applications: () =>
            import(
                "@/pages/Home/ApplicationForISC/ApplicationsReview/components/Applications"
            ),
    },
    computed: {
        windowWidth() {
            return this.$store.state.windowWidth;
        },

    },
    created() {
        const query = this.$route.query;
        if (query.study_year && query.reg_period && this.windowWidth < 992) {
            this.clickNotClose = false;
            this.isEmailSidebarActive = false;
        }
        this.setSidebarWidth()
    },
    methods: {
        toggleTodoSidebar(value = false) {
            // Функция открытия sidebar с фильтрами для моб устройств
            if (!value && this.clickNotClose) return;
            this.isEmailSidebarActive = value;
        },
        setSidebarWidth() {
            if (this.windowWidth < 992) {
                this.isEmailSidebarActive = this.clickNotClose = false;
            } else {
                this.isEmailSidebarActive = this.clickNotClose = true;
            }
        },

        clearSearch(){
            this.searchQuery = '';
        },
        async getDataOfStudents() {
            try {
                this.$vs.loading();

                // Очистка перед записью, чтобы перерендерить компонент
                this.listApplicationOfStudents = null;

                // Запрос и запись
                this.listApplicationOfStudents = (
                    await this.$http.get(this.urlForGetListStudents, {
                        params: this.$route.query,
                    })
                ).data;
            } catch (e) {
            } finally {
                this.$vs.loading.close();
            }
        },
        addStudentsInList(list) {
            // Запись студентов в массив списка для рендера
            list.forEach((student) => {
                this.listApplicationOfStudents.results.push(student);
            });
        },
        clearStudentsInList() {
            this.listApplicationOfStudents = null;
        },
    },

    watch: {
        windowWidth() {
            this.setSidebarWidth();
        },
        "$route.query"() {
            const query = this.$route.query;
            if (
                query.study_year &&
                query.reg_period &&
                query.full_name &&
                this.windowWidth < 992
            ) {
                this.clickNotClose = false;
                this.isEmailSidebarActive = false;
            }
        },
        searchQuery(){
            let queries = { ...this.$route.query };
            queries['full_name'] = this.searchQuery;
            this.$router.replace({ name: this.$route.name, query:queries })
        }
    },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/vuexy/apps/todo.scss";
#todo-app::v-deep {
    .vs-sidebar--items {
        overflow-y: auto !important;
    }
}

.custom-sidebar::v-deep .vs-sidebar--background {
    position: absolute !important;
}
</style>
